var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.parameterComponent)?_c('keep-alive',[_c(_vm.parameterComponent,{tag:"component",attrs:{"kind":_vm.kind,"disabled":_vm.isFinished}})],1):_c('div',[_vm._v("parameter not found")])
}
var staticRenderFns = []

export { render, staticRenderFns }